export function toggleIsolatedLegendItem(
    currentIsolatedLabel: string | null,
    clickedLabel: string,
): string | null {
    if (!clickedLabel.trim()) {
        return currentIsolatedLabel;
    }

    return currentIsolatedLabel === clickedLabel ? null : clickedLabel;
}

export function isLegendDatasetHidden(
    isolatedLabel: string | null,
    datasetLabel: string,
): boolean {
    if (!isolatedLabel) {
        return false;
    }

    return datasetLabel !== isolatedLabel;
}
